import React, { useReducer, createContext } from "react";
import { getLocalStorage, setLocalStorage } from "services/localStorageService";

export const LanguageContext = createContext();
const LOCALSTORAGE_KEY = "comeforhealth_language";

const initialState = {
  language: {
    name: "English",
    code: getLocalStorage(LOCALSTORAGE_KEY) ?? "en",
  },
};

const languageOptions = {
  en: {
    name: "English",
    code: "en",
  },
  cn: {
    name: "Chinese",
    code: "cn",
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case "Change_To":
      setLocalStorage(LOCALSTORAGE_KEY, action.payload.code);
      return {
        language: languageOptions[action.payload.code] ?? languageOptions["en"],
      };
  }
};

export const LanguageContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <LanguageContext.Provider value={[state, dispatch]}>
      {props.children}
    </LanguageContext.Provider>
  );
};
